import { ApiFinancialRequest } from "data/ApiFinancial";

export const verifyExistFinancialCourse = async (id: number): Promise<boolean> => {
  return ApiFinancialRequest<{
    Course: { id: number };
  }>({
    query: `query GetOne($id: Int!) { Course(id: $id, includeInactivePrices: true) { id } }`,
    variables: { id },
    headers: {
      "Cache-Control": "no-cache",
      "Pragma": "no-cache"
    },
    data: {
      fetchPolicy: "network-only"
    }
  }).then((response) => {
    if (!response?.data?.data?.Course) {
      throw new Error("Não encontrado", {
        cause: { response: response?.data || response },
      });
    }
    return true;
  }).catch((error) => {
    console.error(error);
    return false;
  });
}